var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-event"},[_c('Nav',{attrs:{"activeNav":"home"}}),_c('Banner'),_c('Video',{attrs:{"detail":_vm.detail}}),(_vm.detail)?_c('Process',{attrs:{"detail":_vm.detail}}):_vm._e(),_c('News'),_c('Works'),_c('Interview'),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }